export const skillsData = [
    'Tensorflow',
    'Pytorch',
    'OpenCV',
    'AWS',
    'Python',
    'C++',
    'CUDA',
    'MATLAB',
    'React',
    'Django',
    'Docker',
    'Kubernetes',
    'HTML',
    'Figma',
    'Javascript',
    'CSS',
    'Next JS',
    'Git'
]
